export const FILE_UPLOAD_ACCEPTED_FORMATS =
  'image/png,image/jpeg,image/webp,.png,.jpg,.jpeg,.webp,application/pdf,.pdf';
